<div class="grey-title">
  <span>&nbsp;</span>
  @if (signatureRole.id) {
    <h2 mat-dialog-title>Edit Signature Matrix</h2>
  } @else {
    <h2 mat-dialog-title>Add Signature Role</h2>
  }
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <form
    [formGroup]="form"
    (ngSubmit)="onSave()"
    id="ngForm"
    autocomplete="off"
    appUserManual
    [userManualKey]="'signature-role-edit-dialog'"
  >
    <div class="table">
      <div class="row">
        <div class="cell">
          <mat-form-field appearance="fill" class="no-validation role">
            <mat-label>Role:</mat-label>
            <input matInput formControlName="name" type="text" name="name" [(ngModel)]="signatureRole.name" required="true" />
            @if (form.controls['name'].hasError('required')) {
              <mat-error>Role is required</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="cell">
          <mat-form-field appearance="fill" class="no-validation verified">
            <mat-label>Validation:</mat-label>
            <input matInput formControlName="description" type="text" name="description" [(ngModel)]="signatureRole.description" />
            @if (form.controls['description'].hasError('required')) {
              <mat-error>Verified is required</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="cell">
          <mat-form-field appearance="fill" class="no-validation role">
            <mat-label>Group mail:</mat-label>
            <input matInput formControlName="groupEmail" type="text" name="groupEmail" [(ngModel)]="signatureRole.groupEmail" />
          </mat-form-field>
        </div>
        <div class="cell">&nbsp;</div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="error-message">
    @if (errorMsg) {
      <app-error-message [errorMessage]="errorMsg"></app-error-message>
    }
  </div>

  <div>
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <app-commit-button
      [isRoundButton]="true"
      [buttonStatus]="buttonStatus"
      buttonTestId="userEditDialogSave"
      (commitButtonClicked)="onSave()"
      idleLabel="Save"
    ></app-commit-button>
  </div>
</mat-dialog-actions>
